import { RouterProvider } from 'react-router-dom';
import { router } from 'components/app-routes.component';
import 'masonry-registries'; // initialize masonry registries

export function App() {
  return <RouterProvider router={router} />;
}
